module.exports = __webpack_public_path__ + "assets/02bcad31c08de89f57018a90f09d1875.png";